import './ovp-kaching-sdk.js';

const $ = (s, root = document.querySelector("#oculabs-vision-funnel")) => root.querySelector(s);
const $$ = (s, root = document.querySelector("#oculabs-vision-funnel")) => [...root.querySelectorAll(s)];
const form = $('#vision-purchase-form');
const atc = $('#vision-add-to-cart');
const root = new URL('./', import.meta.url);
const clone = value => JSON.parse(JSON.stringify(value));
let cfg, operations, widget, ready = false, busy = false, generation = 0;
let selectedQuantity = 3, country = 'US', currency = 'USD', quotes = new Map();
let recurringPrices = new Map();
function money(amount, code = currency, display = 'code') {
  return new Intl.NumberFormat('en', { style: 'currency', currency: code, currencyDisplay: display }).format(Number(amount));
}
function mode() { return $('input[name="select-frequency"]:checked')?.dataset.fType === 'subscribe-save' ? 'subscription' : 'one-time'; }
function size() { return $('input[name="dog-size"]:checked'); }
function planFor(qty) { return cfg.plans.find(p => p.id === cfg.bars.find(b => b.quantity === qty)?.sellingPlanId); }
function cadence(qty) { const months = planFor(qty)?.months; return months === 1 ? 'every month' : `every ${months} months`; }
function setError(message) {
  const el = $('#vision-commerce-error');
  el.textContent = message || ''; el.hidden = !message;
  $('#vision-commerce-retry').hidden = !message;
}
function setBusy(value) {
  busy = value;
  form.classList.toggle('vision-cart-busy', value);
  $$('input,select', form).forEach(input => { input.disabled = value; });
  atc.disabled = value || !ready;
  atc.setAttribute('aria-busy', String(value || !ready));
  $('#vision-market').disabled = value;
  if (value) atc.textContent = 'Preparing your cart…';
  else render();
}
const waitUntil = async (predicate, timeout = 15000) => {
  const end = Date.now() + timeout;
  while (Date.now() < end) {
    if (predicate()) return;
    await new Promise(resolve => setTimeout(resolve, 35));
  }
  throw new Error('Purchase options took too long to load. Please try again.');
};
function captureOneTime(block) {
  return new Promise((resolve, reject) => {
    const button = $('.kaching-bundles__subscriptions__link', block);
    if (!button) return reject(new Error('The one-time purchase option is unavailable.'));
    const timer = setTimeout(() => { block.removeEventListener('add-to-cart-requested', listener); reject(new Error('Could not read the one-time purchase option.')); }, 4000);
    function listener(event) {
      event.preventDefault(); event.stopPropagation();
      clearTimeout(timer); block.removeEventListener('add-to-cart-requested', listener);
      resolve(clone(event.detail.items));
    }
    block.addEventListener('add-to-cart-requested', listener);
    button.click();
  });
}
async function readBundleOptions(version) {
  const block = $('kaching-bundles-block', widget);
  if (!block) throw new Error('Purchase options are unavailable.');
  const next = new Map();
  for (const bar of cfg.bars) {
    block.selectedDealBarId = bar.id;
    await waitUntil(() => block.items()?.find(i => Number(i.id) === cfg.variantId)?.quantity === bar.quantity);
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    const subscriptionItems = clone(block.items());
    const pricing = clone(block.pricing());
    const oneTimeItems = await captureOneTime(block);
    if (version !== generation) return;
    const sub = subscriptionItems.find(i => Number(i.id) === cfg.variantId);
    const otp = oneTimeItems.find(i => Number(i.id) === cfg.variantId);
    if (!sub || sub.selling_plan !== bar.sellingPlanId || !otp || otp.selling_plan || sub.quantity !== bar.quantity || otp.quantity !== bar.quantity) {
      throw new Error('Could not match this purchase option to Vision Bites.');
    }
    next.set(bar.quantity, { pricing, subscriptionItems, oneTimeItems });
  }
  if (version !== generation) return;
  block.selectedDealBarId = cfg.bars.find(b => b.quantity === selectedQuantity)?.id;
  quotes = next; ready = true; setError(''); render();
}
async function loadOptions() {
  const version = ++generation;
  ready = false; quotes.clear(); render();
  country = host.country; currency = host.currency;
  if (widget) widget.remove();
  widget = document.createElement('kaching-bundle-component');
  widget.hidden = true; widget.setAttribute('aria-hidden', 'true');
  for (const [key, value] of Object.entries({ 'shop-domain': cfg.shopDomain, 'storefront-token': cfg.storefrontToken,
    'product-id': cfg.productId, 'selected-variant-id': cfg.variantId, 'deal-block-id': cfg.dealBlockId, country, language: 'EN' })) {
    widget.setAttribute(key, String(value));
  }
  const loaded = new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Unable to load current purchase options. Please try again.')), 20000);
    widget.addEventListener('loaded', () => { clearTimeout(timer); resolve(); }, { once: true });
  });
  document.body.append(widget);
  try {
    const [product] = await Promise.all([
      graphql('VisionProductRead', { id: `gid://shopify/ProductVariant/${cfg.variantId}`, country }), loaded
    ]);
    if (version !== generation) return;
    if (!product?.availableForSale || product.sellingPlanAllocations.pageInfo.hasNextPage) throw new Error('Vision Bites is currently unavailable. Please try again later.');
    recurringPrices = new Map(product.sellingPlanAllocations.nodes.map(p => [Number(p.sellingPlan.id.split('/').pop()), p.priceAdjustments[0]?.price]));
    if (cfg.bars.some(bar => !recurringPrices.has(bar.sellingPlanId))) throw new Error('A subscription option has changed. Please try again later.');
    await readBundleOptions(version);
  }
  catch (error) { if (version === generation) { ready = false; setError(error.message); render(); } }
}
function render() {
  const subscription = mode() === 'subscription';
  const selectedSize = size();
  $('#vision-serving-note').textContent = `Daily serving: ${selectedSize?.dataset.dailyChews || 2} soft chews. Choose the jar quantity and delivery interval that suit your routine.`;
  for (const card of $$('.frequency-product__col[data-vision-quantity]')) {
    const qty = Number(card.dataset.visionQuantity), quote = quotes.get(qty);
    const isSub = card.dataset.visionMode === 'subscription';
    const checked = qty === selectedQuantity;
    card.setAttribute('aria-pressed', String(checked));
    $('input[type=radio]', card).checked = checked;
    $('.cwr-product-card', card).classList.toggle('active--option', checked);
    const price = quote && (isSub ? quote.pricing.discountedPrice.amount : quote.pricing.discountedPriceWithoutSellingPlan.amount);
    $('.price', card).textContent = quote ? money(price) : 'Loading…';
    $('.compare-price', card).textContent = quote ? money(quote.pricing.fullPrice.amount) : '';
    $('.cwr-product-card__save-price', card).textContent = quote ? `Save ${money(quote.pricing.fullPrice.amount - price, currency, 'narrowSymbol')}` : '';
  }
  const quote = quotes.get(selectedQuantity);
  const amount = quote && (subscription ? quote.pricing.discountedPrice.amount : quote.pricing.discountedPriceWithoutSellingPlan.amount);
  $('#vision-order-summary').textContent = quote
    ? `${selectedQuantity} jar${selectedQuantity === 1 ? '' : 's'} · ${subscription ? `Subscription, delivered ${cadence(selectedQuantity)}` : 'One-time purchase'} · ${money(amount)} today.`
    : 'Loading current purchase options…';
  const recurring = recurringPrices.get(planFor(selectedQuantity)?.id);
  $('#vision-recurring-summary').hidden = !subscription || !quote || !recurring;
  $('#vision-recurring-summary').textContent = recurring
    ? `Recurring subtotal: ${money(Number(recurring.amount) * selectedQuantity, recurring.currencyCode)} ${cadence(selectedQuantity)}, before applicable discounts, shipping and taxes. Pause or cancel anytime.` : '';
  const gifts = subscription ? cfg?.gifts.filter(g => g.unlock <= selectedQuantity) || [] : [];
  $('#vision-gifts').hidden = !gifts.length;
  $('#vision-gift-list').replaceChildren(...gifts.map(g => { const li = document.createElement('li'); li.textContent = `${g.title} · FREE`; return li; }));
  if (!busy) {
    atc.disabled = !ready;
    atc.setAttribute('aria-busy', String(!ready));
    atc.textContent = ready ? `Add to cart · ${money(amount)}` : 'Loading purchase options…';
  }
}
async function graphql(operationName, variables) {
  let response;
  try { response = await fetch(`https://${cfg.shopDomain}/api/${cfg.apiVersion}/graphql.json`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.storefrontToken },
    body: JSON.stringify({ operationName, query: operations, variables }), signal: AbortSignal.timeout(25000)
  }); } catch { throw new Error('Unable to connect to the store. Check your connection and try again.'); }
  if (!response.ok) throw new Error('Your cart could not be reached. Please try again.');
  const result = await response.json();
  if (result.errors?.length) throw new Error(result.errors.map(e => e.message).join(' '));
  const payload = result.data[Object.keys(result.data)[0]];
  if (payload?.userErrors?.length) throw new Error(payload.userErrors.map(e => e.message).join(' '));
  return payload;
}

const host = JSON.parse(document.querySelector('#ovp-host').textContent);
const route = path => `${host.cartRoot.replace(/\/$/, '')}/${path}`;
let pendingAdd = null;
async function cartRead() {
  const response = await fetch(route('cart.js'), { credentials: 'same-origin', cache: 'no-store' });
  if (!response.ok) throw new Error('Your cart could not be reached. Please try again.');
  return response.json();
}
function updateCount(cart) {
  const count = $('#vision-cart-count');
  count.hidden = !cart.item_count; count.textContent = String(cart.item_count || '');
}
async function openNativeCart(state, trigger = atc) {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer?.renderContents) { location.href = host.cartUrl; return; }
  try {
    drawer.setActiveElement?.(trigger);
    if (!state?.sections?.['cart-drawer']) {
      const url = new URL(location.href);
      url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart refresh failed');
      state = { sections: await response.json() };
    }
    if (!state.sections['cart-drawer']) throw new Error('Cart section unavailable');
    drawer.renderContents(state);
    const cart = await cartRead();
    drawer.classList.toggle('is-empty', !cart.item_count);
    updateCount(cart);
    drawer.open?.(trigger);
  } catch { location.href = host.cartUrl; }
}
async function itemsForSelection() {
  const block = $('kaching-bundles-block', widget);
  block.selectedDealBarId = cfg.bars.find(b => b.quantity === selectedQuantity).id;
  await waitUntil(() => block.items()?.find(i => Number(i.id) === cfg.variantId)?.quantity === selectedQuantity);
  block.rotateBundleNonce?.();
  await new Promise(resolve => requestAnimationFrame(resolve));
  const subscription = mode() === 'subscription';
  const items = subscription ? clone(block.items()) : await captureOneTime(block);
  if (subscription) for (const gift of cfg.gifts.filter(g => g.unlock <= selectedQuantity)) {
    items.push({ id: gift.variantId, quantity: 1, properties: { _gift: 'free' } });
  }
  const main = items.find(i => Number(i.id) === cfg.variantId);
  if (!main || main.quantity !== selectedQuantity || (main.selling_plan || null) !== (subscription ? planFor(selectedQuantity).id : null)) {
    throw new Error('The selected purchase option has changed. Please reload the options.');
  }
  const attempt = crypto.randomUUID();
  const params = new URLSearchParams(location.search);
  for (const item of items) {
    item.properties = { ...item.properties, _funnel: cfg.attribution, _funnel_add: attempt };
    if (Number(item.id) === cfg.variantId) {
      item.properties._dog_size = size().value;
      item.properties._daily_chews = size().dataset.dailyChews;
      for (const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid']) {
        if (params.has(key)) item.properties['_' + key] = params.get(key).slice(0,250);
      }
    }
  }
  return { attempt, items };
}
async function addToNativeCart(event) {
  event.preventDefault(); event.stopImmediatePropagation();
  if (busy || !ready) return;
  setBusy(true); setError('');
  let sent = false;
  try {
    if (pendingAdd) {
      const cart = await cartRead();
      if (cart.items.some(i => i.properties?._funnel_add === pendingAdd)) {
        pendingAdd = null; await openNativeCart(); return;
      }
      pendingAdd = null;
    }
    const selection = await itemsForSelection();
    pendingAdd = selection.attempt;
    sent = true;
    const response = await fetch(route('cart/add.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: selection.items, sections: ['cart-drawer','cart-icon-bubble'], sections_url: location.pathname + location.search }),
      signal: AbortSignal.timeout(25000)
    });
    const result = await response.json();
    // Shopify can add the available quantity and still return a stock error.
    // Reconcile the attempt before allowing another add, including HTTP errors.
    if (!response.ok) throw new Error(result.description || result.message || 'This selection could not be added.');
    pendingAdd = null;
    await openNativeCart(result);
  } catch (error) {
    if (sent && pendingAdd) {
      try {
        const cart = await cartRead();
        if (cart.items.some(i => i.properties?._funnel_add === pendingAdd)) {
          pendingAdd = null;
          setError(error.message);
          await openNativeCart();
          const cartError = document.querySelector('#CartDrawer-CartErrors');
          if (cartError) cartError.textContent = error.message;
          return;
        }
      } catch { /* Keep the attempt for a read-before-retry check. */ }
    }
    setError(pendingAdd ? 'We could not confirm the update. Open your cart to check before trying again.' : error.message);
  } finally { setBusy(false); }
}
form.addEventListener('submit', addToNativeCart, true);
$$('.frequency-product__col[data-vision-quantity]').forEach(card => {
  const select = () => { if (busy) return; selectedQuantity = Number(card.dataset.visionQuantity); render(); };
  card.addEventListener('click', select); $('input', card).addEventListener('change', select);
  card.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); select(); } });
});
$$('input[name="dog-size"],input[name="select-frequency"]').forEach(input => input.addEventListener('change', render));
$('#vision-market').addEventListener('change', () => {
  const localization = document.querySelector('#vision-localization');
  localization.querySelector('[name="return_to"]').value = location.pathname + location.search + '#main-product-box-wrapper';
  localization.requestSubmit();
});
$('#vision-commerce-retry').addEventListener('click', () => cfg ? loadOptions() : initialize());
$('.cwr-header__cart').addEventListener('click', event => { event.preventDefault(); openNativeCart(null, event.currentTarget); });
async function initialize() {
  try {
    setError('');
    $('#vision-market').disabled = false;
    const responses = await Promise.all([host.configUrl, host.productQueryUrl].map(url => fetch(url, { signal: AbortSignal.timeout(15000) })));
    if (responses.some(response => !response.ok)) throw new Error('Purchase options are unavailable. Please reload the page.');
    cfg = await responses[0].json(); operations = await responses[1].text();
    selectedQuantity = cfg.defaultQuantity; country = host.country; currency = host.currency;
    await loadOptions();
    try { updateCount(await cartRead()); } catch { /* The native cart remains available through /cart. */ }
  } catch (error) { setError(error.message); atc.disabled = true; atc.textContent = 'Purchase options unavailable'; }
}
await initialize();
